import "./style.scss";
import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import { Clip } from "@/src/svg/Clip";
import { File } from "@/src/svg/File";
import { Delete } from "@/src/svg/Delete";

interface IOnSubmit {
  text: string;
  name: string;
  phone: string;
  email: string;
  files: File[];
}

const LeaveForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm<IOnSubmit>();

  const [formData, setFormData] = useState<IOnSubmit>();
  const [popUpBool, setPopUpBool] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files;
    if (newFiles) {
      const updatedFiles = [...selectedFiles, ...Array.from(newFiles)];
      setSelectedFiles(updatedFiles);
      setValue("files", updatedFiles, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileDelete = (indexToDelete: number) => {
    const updatedFiles = selectedFiles.filter((_, index) => index !== indexToDelete);
    setSelectedFiles(updatedFiles);
    setValue("files", updatedFiles, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit = (data: IOnSubmit) => {
    console.log("Submitted data:", data);
    setFormData(data);
    setSelectedFiles([]);
    reset();
  };

  return (
    <form className="leave-form" onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className="leave-form-title">
        <p>Leave Your Message</p>
      </div>
      <div className="leave-form-textarea">
        <textarea
          placeholder="Text..."
          {...register("text", {
            required: "Text is required",
            validate: (value) => {
              const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
              return wordCount >= 2 || "Minimum 2 words required";
            },
          })}
        />
        {errors.text && <p className="error">{errors.text.message}</p>}
      </div>
      <div className="leave-form-input">
        <input
          type="text"
          placeholder="Name:"
          {...register("name", {
            required: "Name is required",
            minLength: { value: 2, message: "Minimum 2 characters" },
          })}
        />
        {errors.name && <p className="error">{errors.name.message}</p>}
      </div>
      <div className="leave-form-input">
        <input
          type="tel"
          placeholder="Phone:"
          {...register("phone", {
            required: "Phone is required",
            pattern: {
              value: /^\+?[0-9\s\-]{7,15}$/,
              message: "Invalid phone number",
            },
          })}
        />
        {errors.phone && <p className="error">{errors.phone.message}</p>}
      </div>
      <div className="leave-form-input">
        <input
          type="email"
          placeholder="Email:"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^\S+@\S+$/i,
              message: "Invalid email address",
            },
          })}
        />
        {errors.email && <p className="error">{errors.email.message}</p>}
      </div>
      <div className="leave-form-footer">
        <div className="leave-form-submit">
          <button type="submit">Send</button>
        </div>
        <div className={`leave-form-popUp-clip ${popUpBool ? "active" : ""}`} onClick={() => setPopUpBool(!popUpBool)}>
          <Clip />
        </div>
        {errors.files && <p className="error">{errors.files.message}</p>}
      </div>
      <div className={`leave-form-popUp ${!popUpBool ? "hidden" : ""}`}>
        <input type="file" multiple ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
        <input
          type="hidden"
          {...register("files", {
            validate: (value) => (value && value.length > 0 ? true : "At least one file is required"),
          })}
        />
        <div className="leave-form-popUp-button" onClick={() => fileInputRef.current?.click()}>
          <div className="leave-form-popUp-button-text">
            <p className="first">Attach scan copies of your documents</p>
            <p className="second">and</p>
            <p className="third">Browse Files</p>
          </div>
          <div className="leave-form-popUp-button-count">
            <p>{selectedFiles.length} Of 100</p>
          </div>
        </div>
        {selectedFiles.length > 0 ? (
          <>
            <div className="leave-form-popUp-line"></div>
            <div className="leave-form-popUp-items">
              {selectedFiles.map((file, index) => (
                <div className="leave-form-popUp-item" key={index}>
                  <div className="file-svg first">
                    <div className="file-svg second">
                      <File />
                    </div>
                  </div>
                  <p>{file.name}</p>
                  <div className="file-delete" onClick={() => handleFileDelete(index)}>
                    <Delete />
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : null}
      </div>
    </form>
  );
};

export default LeaveForm;
